import * as React from "react"
import { useTranslation } from "react-i18next"
import { observer } from "mobx-react"
import consola from "consola"

import DangerousIcon from "@mui/icons-material/Dangerous"
import { Button, Typography } from "@mui/material"
import Box from "@mui/material/Box"
import { styled, useTheme } from "@mui/material/styles"

import cloud from "@osapiens/cloud-interop/lib"

import { isCloudEnv } from "utils/env"

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flex: 4,
  justifyContent: "space-evenly",
  flexDirection: "column",
  alignItems: "center",
  overflowY: "scroll",
  background: `url(${""}) repeat content-box`,
}))
const AccessDenied: React.FC = () => {
  const { t } = useTranslation("app")
  const theme = useTheme()

  const color = theme.palette.error.main
  React.useEffect(() => {
    // on screen leave
    return () => {
      // clearCache()
    }
    // eslint-disable-next-line
  }, [])

  // TODO: aldd all i18n texts to locales and refactor file

  const handleLogout = () => {
    if (isCloudEnv()) {
      cloud.navigation.logout()
    } else {
      consola.error(
        "Logout not possible: Osapiens cloud interop API (window.parent.primingcloud) not available."
      )
    }
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Container>
        <DangerousIcon
          sx={{
            color,
            width: 125,
            height: 125,
          }}
        />
        <Typography variant="h5" sx={{ color }}>
          {t("AccessDenied")}
        </Typography>
        <Typography>{t("speakToYourAdmin")}</Typography>
        <Button sx={{ color }} onClick={handleLogout}>
          {/* <LogoutIcon
          fill={theme.palette.error.light}
          className="logout-icon"
        /> */}{" "}
          {t("logout")}
        </Button>
      </Container>
      <Box sx={{ flex: 3 }}></Box>
    </Box>
  )
}

export default observer(AccessDenied)
